import { c as _c } from "react/compiler-runtime";
import { Dialog } from '@mui/material';
import type { PropsWithChildren } from 'react';
import { SlideUpTransition } from '../animations/transitions';
interface BottomDialogProps {
  open: boolean;
  isFullScreen?: boolean;
}
export const BottomDialog = props => {
  const $ = _c(7);
  const {
    open,
    children,
    isFullScreen
  } = props;
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      transition: SlideUpTransition
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const t1 = isFullScreen ? "0" : "60px";
  let t2;
  if ($[1] !== t1) {
    t2 = {
      "& .MuiDialog-paper": {
        width: "100%",
        maxWidth: "100%",
        height: "85%",
        margin: 0,
        alignSelf: "end",
        marginLeft: t1
      }
    };
    $[1] = t1;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] !== children || $[4] !== open || $[5] !== t2) {
    t3 = <Dialog slots={t0} open={open} sx={t2}>{children}</Dialog>;
    $[3] = children;
    $[4] = open;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};